var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3846 3.0818L18.8299 5.50924C17.7293 4.62973 16.4845 4.18998 15.0953 4.18998C13.21 4.18998 11.7284 4.71768 10.6504 5.77309C9.57247 6.8285 8.92524 8.01144 8.70875 9.3219H17.9368L17.585 11.1029H8.49225L8.46519 11.6174L8.49225 12.8311H17.1926L16.8408 14.6121H8.7764C9.11918 16.3975 9.86112 17.7102 11.0022 18.5501C12.1433 19.3901 13.431 19.81 14.8653 19.81C16.5612 19.81 17.8827 19.3747 18.8299 18.504V21.2348C17.7113 21.7449 16.4665 22 15.0953 22C10.116 22 7.1121 19.5374 6.08375 14.6121H4L4.39239 12.8311H5.79961C5.78157 12.6201 5.77255 12.2243 5.77255 11.6438V11.1029H4L4.39239 9.3219H5.9755C6.44458 6.89446 7.53156 5.06728 9.23646 3.84037C10.9413 2.61346 12.9123 2 15.1495 2C16.8273 2 18.239 2.3606 19.3846 3.0818Z",
    fill: "#111928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.aa8468e9b64d2c8110c974627637a990.svg";
export { ForwardRef as ReactComponent };